import { formatDate } from 'utils/date';
import { ListCard } from 'components/list-card';
import { EventPayment } from 'store/api/event/types';
import {
  eventPaymentTypeLabel,
  eventPaymentTransactionLabel,
} from 'store/api/event';

export const PaymentListCard = ({ data }: { data: EventPayment }) => (
  <ListCard
    values={[
      eventPaymentTypeLabel[data.type],
      data.transaction && eventPaymentTransactionLabel[data.transaction],
      data.notes,
      data.amount,
      data.date && formatDate(data.date),
      data.paidBy?.name,
      data.paymentMethod?.name,
      data.cashed ? 'Yes' : 'No',
    ]}
  />
);
